/* eslint-disable react/display-name */
import DomainsCreateModal from './DomainsCreateController'

export default DomainsCreateModal
